<template>
    <v-container style="width: 85%; padding-top: 7%;" class="text-left">
      <v-row class="mb-5">
        <v-col md="4" class="pr-10">
          <sub class="header">ORIENTAMOS NUESTROS SERVICIOS A</sub>
        </v-col>
        <v-col md="4" align-self="end">
          <h5 class="number">1.</h5>
          <body-1 class="body">Empresas generadoras</body-1>
        </v-col>
        <v-col md="4" align-self="end">
          <h5 class="number">2.</h5>
          <body-1 class="body">Empresas comercializadoras mayoristas</body-1>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="4" class="pr-15">
          <h5 class="number">3.</h5>
          <body-1 class="body">Inversionistas en generación</body-1>
        </v-col>
        <v-col md="4" class="pr-15">
          <h5 class="number">4.</h5>
          <body-1 class="body">Banca de Inversión</body-1>
        </v-col>
        <v-col md="4">
          <h5 class="number">5.</h5>
          <body-1 class="body">Empresas aseguradoras</body-1>
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
export default {
  name: 'app',
}
</script>

<style>

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.body {
  color: #161c2d;
}

.header {
  font-weight: 400;
  font-size: 1.8rem;
  line-height: 2.2rem;
  color: #161c2d;
}

.number {
  font-weight: 400;
  font-size: 2rem;
  color: #00838f;
}

</style>



// WEBPACK FOOTER //
// src/components/ClientsLarge.vue